import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'bt-approve-order-note',
  standalone: false,
  templateUrl: './approve-order-note.html',
  styleUrl: './approve-order-note.scss'
})
export class ApproveOrderNoteComponent {
	readonly #dialogRef = inject(MatDialogRef<ApproveOrderNoteComponent>);

	note = '';

	public onClose(confirm: boolean)  {
    if(confirm) this.#dialogRef.close(this.note);
    else this.#dialogRef.close(null);
	}
}
